import { type ReactNode } from 'react'

import { Trans } from '@/components/Trans'

interface EIPMonitorMetric {
  i18nKey: string
  label: string
  value: ReactNode
}

const MOCK_MONITOR_METRICS: EIPMonitorMetric[] = [
  {
    i18nKey: 'detail.monitorTotalDataTransfer',
    label: 'Total Data Transfer (GB)',
    value: (
      <>
        <span className="text-tertiary">Total</span> 4 <span className="text-tertiary">TX</span> 2.5{' '}
        <span className="text-tertiary">RX</span> 1.5
      </>
    ),
  },
  {
    i18nKey: 'detail.monitorBandwidthUtilization',
    label: 'Bandwidth Utilization',
    value: '90%',
  },
  {
    i18nKey: 'detail.monitorBandwidthUsage',
    label: 'Bandwidth Usage (Gbps)',
    value: (
      <>
        <span className="text-tertiary">Total</span> 4 <span className="text-tertiary">TX</span> 2.5{' '}
        <span className="text-tertiary">RX</span> 1.5
      </>
    ),
  },
  {
    i18nKey: 'detail.monitorPacketsPerSecond',
    label: 'Packets Per Second (PPS)',
    value: (
      <>
        <span className="text-tertiary">TX</span> 5073 <span className="text-tertiary">RX</span>{' '}
        8073
      </>
    ),
  },
]

export function MonitorContent() {
  return (
    <div className="bg-neutral-50 rounded-lg p-4">
      <div className="grid grid-cols-4 gap-4">
        {MOCK_MONITOR_METRICS.map((metric) => (
          <div key={metric.i18nKey}>
            <div className="t-xs text-secondary mb-1">
              <Trans ns="eip" i18nKey={metric.i18nKey}>
                {metric.label}
              </Trans>
            </div>
            <div className="t-sb text-primary">{metric.value}</div>
          </div>
        ))}
      </div>
      <div className="border-t border-neutral-200 pt-3 mt-4">
        <span className="t-x-sb text-highlight cursor-pointer">
          <Trans ns="eip" i18nKey="detail.monitorViewDetail">
            View Detail
          </Trans>
        </span>
      </div>
    </div>
  )
}
